import { ChangedAttribute } from './changed-attribute';

export class MaterialChange {
  constructor(
    public changedMaterials: ChangedAttribute[],
    public initial: boolean,
    public existingFilesAmount: number
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/material-change.ts